// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__IwQIZ","topBottomGutter":"Layout_topBottomGutter__2OzXI"};